


























































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import ScheduleGrid from "./ScheduleGrid.vue";
import ScheduleForm from "./ScheduleForm.vue";
import VacationForm from "./VacationForm.vue";
import OpenShiftsTab from "./components/OpenShiftsTab.vue";
import TransferRequestsTab from "./components/TransferRequestsTab.vue";
import DailyReportTab from "./components/DailyReportTab.vue";
import TrendAnalysisTab from "./components/TrendAnalysisTab.vue";
import TimeOffRequestTab from "./components/TimeOffRequestTab.vue";
import SendScheduleSMSModal from "./components/SendScheduleSMSModal.vue";
import UpdatePPDModal from "./components/UpdatePPDModal.vue";
import ActionChoiceDialog from "./components/ActionChoiceDialog.vue";
import ScheduleSettingsTab from "./components/ScheduleSettingsTab.vue";
import {
  Schedule,
  CreateScheduleRequest,
  ScheduleStatus,
  Shift,
  Department,
  DepartmentTitle,
  PatientCensus,
} from "@/api";
import { checkSelfRole } from "@/common/role_utils";
import _ from "lodash";

@Component({
  components: {
    ScheduleGrid,
    ScheduleForm,
    VacationForm,
    OpenShiftsTab,
    SendScheduleSMSModal,
    TransferRequestsTab,
    TimeOffRequestTab,
    DailyReportTab,
    TrendAnalysisTab,
    UpdatePPDModal,
    ActionChoiceDialog,
    ScheduleSettingsTab,
  },
})
export default class AdminScheduleLayout extends Vue {
  activeTab = 0;
  formDialog = false;
  selectedSchedule: Schedule | null = null;

  smsDialog = false;

  ppdDialog = false;
  selectedPPDDate = "";

  censusDialog = false;
  selectedCensusForm: Partial<PatientCensus> = {};

  choiceDialog = false;
  // eslint-disable-next-line
  choicePayload: { date: string; employeeId: number } | null = null;

  vacationFormDialog = false;
  // eslint-disable-next-line
  selectedVacationData: any = null;

  filters = {
    employeeName: "",
    startDate: "",
    endDate: "",
    status: "",
    shiftId: null as number | null,
    departmentId: null as number | null,
    titleId: null as number | null,
  };

  startDateMenu = false;
  endDateMenu = false;

  statusOptions = Object.values(ScheduleStatus);

  viewMode: "week" | "month" = "month";
  currentDate = moment();

  get viewStart(): string {
    return (
      this.filters.startDate ||
      this.currentDate
        .clone()
        .startOf(this.viewMode)
        .format("YYYY-MM-DD")
    );
  }

  get viewEnd(): string {
    return (
      this.filters.endDate ||
      this.currentDate
        .clone()
        .endOf(this.viewMode)
        .format("YYYY-MM-DD")
    );
  }

  get generatedDays() {
    const days = [];
    let start =
      this.viewMode === "week"
        ? this.currentDate.clone().startOf("week")
        : this.currentDate.clone().startOf("month");

    if (this.filters.startDate) {
      start = moment(this.filters.startDate);
    }

    let end =
      this.viewMode === "week"
        ? this.currentDate.clone().endOf("week")
        : this.currentDate.clone().endOf("month");

    if (this.filters.endDate) {
      end = moment(this.filters.endDate);
    } else if (this.filters.startDate) {
      end =
        this.viewMode === "week"
          ? start.clone().endOf("week")
          : start.clone().endOf("month");
    }

    const hasFilters = !!this.filters.startDate || !!this.filters.endDate;
    const spansMultipleMonths = start.month() !== end.month();
    const showMonth = hasFilters || spansMultipleMonths;

    const current = start.clone();
    while (current.isSameOrBefore(end, "day")) {
      const fullDateStr = current.format("YYYY-MM-DD");
      const censusRecord = this.census.find(
        (c: PatientCensus) =>
          c.census_date && c.census_date.startsWith(fullDateStr),
      );
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const ppdRecord = this.schedulePPD.find((p: any) => {
        const dateVal = p.date || p.Date;
        return dateVal && dateVal.startsWith(fullDateStr);
      });

      // When a title filter is active and no title-specific PPD was found,
      // fall back to the department-level PPD for this date.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const fallbackRecord = this.filters.titleId
        ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
          this.schedulePPDFallback.find((p: any) => {
            const dateVal = p.date || p.Date;
            return dateVal && dateVal.startsWith(fullDateStr);
          })
        : null;

      // Prefer title-filtered record; fall back to department-level; then null
      const effectivePpdRecord = ppdRecord ?? fallbackRecord ?? null;

      const ppdValue = effectivePpdRecord
        ? effectivePpdRecord.ppd != null
          ? effectivePpdRecord.ppd
          : effectivePpdRecord.PPD
        : null;
      const ppdTarget = effectivePpdRecord
        ? effectivePpdRecord.target_ppd != null
          ? effectivePpdRecord.target_ppd
          : effectivePpdRecord.TargetPPD
        : null;
      const ppdActual = effectivePpdRecord
        ? effectivePpdRecord.actual_ppd != null
          ? effectivePpdRecord.actual_ppd
          : effectivePpdRecord.ActualPPD
        : null;
      const totalCount = effectivePpdRecord
        ? effectivePpdRecord.total_count != null
          ? effectivePpdRecord.total_count
          : effectivePpdRecord.TotalCount
        : null;

      const ppdActualWorkHour = effectivePpdRecord
        ? effectivePpdRecord.total_hours != null
          ? effectivePpdRecord.total_hours
          : effectivePpdRecord.TotalHours
        : null;

      if (censusRecord) {
        // eslint-disable-next-line @typescript-eslint/camelcase
        censusRecord.actual_work_hour = ppdActualWorkHour;
        // eslint-disable-next-line @typescript-eslint/camelcase
        censusRecord.target_ppd = ppdTarget;
      }

      days.push({
        name: current.format("ddd").toUpperCase(),
        month: current.format("MMM").toUpperCase(),
        showMonth: showMonth,
        date: current.format("D"),
        fullDate: fullDateStr,
        census: censusRecord ? censusRecord.census : null,
        censusData: censusRecord || null,
        schedPpd: ppdValue != null ? Number(ppdValue).toFixed(2) : null,
        actualPpd: ppdActual != null ? Number(ppdActual).toFixed(2) : null,
        actualWorkHour: ppdActualWorkHour,
        targetPpd: ppdTarget != null ? Number(ppdTarget).toFixed(2) : null,
        totalCount: totalCount,
        schedPpdOver: false,
      });
      current.add(1, "day");
    }
    return days;
  }

  get shiftOptions(): Shift[] {
    return this.$store.getters["shift/shifts"] || [];
  }

  get schedules() {
    let list = this.$store.state.schedule.schedules || [];

    if (this.filters.startDate) {
      list = list.filter((s: Schedule) => s.date >= this.filters.startDate);
    }
    if (this.filters.endDate) {
      list = list.filter((s: Schedule) => s.date <= this.filters.endDate);
    }
    if (this.filters.status) {
      list = list.filter((s: Schedule) => s.status === this.filters.status);
    }

    return list;
  }

  // Combine real store data with our mock grid requirements
  get mappedSchedules() {
    // We will simulate the visual blocks based on the employees
    const visualBlocks: {
      employeeId: number;
      date: string;
      title: string;
      color: string;
      // eslint-disable-next-line
      data: any;
      startTime: string;
      endTime: string;
    }[] = [];

    // Overlay any real schedules from the store
    this.schedules.forEach((s: Schedule) => {
      // Find the employee to get the color, fallback to default
      const emp =
        this.employees.find(e => e.id === s.assignee) || this.employees[0];

      const existingIndex = visualBlocks.findIndex(
        v => v.employeeId === s.assignee && v.date === s.date,
      );
      const block = {
        employeeId: s.assignee || 1, // fallback to employee 1 if unassigned
        date: s.date,
        title: s.facilityName || "N/A",
        color: emp.color,
        data: s,
        startTime: s.startTime,
        endTime: s.endTime,
      };

      if (existingIndex > -1) {
        visualBlocks[existingIndex] = block;
      } else {
        visualBlocks.push(block);
      }
    });

    return visualBlocks;
  }

  @Watch("filters.startDate")
  @Watch("filters.endDate")
  onDateFilterChange() {
    this.fetchData();
  }

  @Watch("filters.departmentId")
  @Watch("filters.titleId")
  onPpdFilterChange() {
    this.fetchData();
  }

  @Watch("$store.state.schedule.lastSocketUpdate")
  onSocketRefresh() {
    this.fetchData();
  }

  mounted() {
    this.fetchData();
    this.fetchOpenShifts();
  }

  get pendingTimeOffCount(): number {
    const requests = this.$store.state.schedule.timeOffRequests || [];
    return requests.filter(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (r: any) => r.status === "pending",
    ).length;
  }

  @Watch("activeTab")
  onActiveTabChange(tab: number) {
    if (tab === 1) {
      this.fetchOpenShifts();
    }
  }

  handleViewModeChange() {
    if (this.filters.startDate && !this.filters.endDate) {
      this.filters.endDate =
        this.viewMode === "week"
          ? moment(this.filters.startDate)
              .endOf("week")
              .format("YYYY-MM-DD")
          : moment(this.filters.startDate)
              .endOf("month")
              .format("YYYY-MM-DD");
    }

    if (!this.filters.startDate && this.filters.endDate) {
      this.filters.startDate =
        this.viewMode === "week"
          ? moment(this.filters.endDate)
              .startOf("week")
              .format("YYYY-MM-DD")
          : moment(this.filters.endDate)
              .startOf("month")
              .format("YYYY-MM-DD");
    }

    this.fetchData();
  }

  async handleFilterTotal(date?: string) {
    this.filters.startDate = date || "";
    this.filters.endDate = date || "";
  }

  async fetchData() {
    try {
      const days = this.generatedDays;
      const start = days.length > 0 ? days[0].fullDate : undefined;
      const end = days.length > 0 ? days[days.length - 1].fullDate : undefined;

      if (start && end) {
        this.$store.commit("schedule/SET_VIEW_RANGE", { start, end });
      }

      const employees = this.$store.dispatch("directory/loadAllEmployees");
      const schedules = this.$store.dispatch("schedule/fetchSchedules", {
        start,
        end,
      });
      const shifts = this.$store.dispatch("shift/fetchShifts");
      const companyTitles = this.$store.dispatch(
        "departmentAdmin/getCompanyTitle",
      );

      // Fetch PPD filtered by the active department/title. When a title filter
      // is set we also fetch the department-level PPD as a fallback so that if
      // the title itself has no PPD entry we can still show the department one.
      const ppdPayload: {
        start?: string;
        end?: string;
        department?: number;
        titleId?: number;
      } = { start, end };

      if (this.filters.departmentId) {
        ppdPayload.department = this.filters.departmentId;
      }
      if (this.filters.titleId) {
        ppdPayload.titleId = this.filters.titleId;
      }

      const schedulePPD = this.$store.dispatch(
        "schedule/getSchedulePPD",
        ppdPayload,
      );

      // Fetch department-level fallback whenever a title filter is active
      let schedulePPDFallback: Promise<unknown> = Promise.resolve();
      if (this.filters.titleId && this.filters.departmentId) {
        schedulePPDFallback = this.$store.dispatch(
          "schedule/getSchedulePPDFallback",
          { start, end, department: this.filters.departmentId },
        );
      } else if (this.filters.titleId) {
        // Title filter without explicit dept: fetch unfiltered dept fallback
        schedulePPDFallback = this.$store.dispatch(
          "schedule/getSchedulePPDFallback",
          { start, end },
        );
      } else {
        // No title filter — clear fallback so generatedDays won't use stale data
        this.$store.commit("schedule/SET_SCHEDULE_PPD_FALLBACK", []);
      }

      const census = this.$store.dispatch("census/getCensus", { start, end });
      const transferRequests = this.$store.dispatch(
        "scheduleTransfer/fetchSchedules",
      );
      const vacations = this.$store.dispatch("vacation/fetchVacations", {
        startDate: start,
        endDate: end,
      });
      const timeOffRequests = this.$store.dispatch(
        "schedule/fetchTimeOffRequests",
        { startDate: start, endDate: end },
      );
      await Promise.all([
        employees,
        schedules,
        shifts,
        companyTitles,
        schedulePPD,
        schedulePPDFallback,
        census,
        transferRequests,
        vacations,
        timeOffRequests,
      ]);
    } catch (error) {
      console.error("Error fetching schedules:", error);
    }
  }

  async fetchOpenShifts() {
    try {
      await this.$store.dispatch("schedule/fetchOpenShifts");
    } catch (error) {
      console.error("Error fetching open shifts:", error);
    }
  }

  openSMSModal() {
    this.smsDialog = true;
  }

  openPPDModal(payload: { date: string }) {
    this.selectedPPDDate = payload.date;
    this.ppdDialog = true;
  }

  onPPDSaved() {
    this.fetchData();
  }

  openNewScheduleForm() {
    this.selectedSchedule = null;
    this.formDialog = true;
  }

  openChoiceDialog(payload: { date: string; employeeId: number }) {
    this.choicePayload = payload;
    this.choiceDialog = true;
  }

  // eslint-disable-next-line
  handleChoice(choice: string) {
    this.choiceDialog = false;
    if (!this.choicePayload) return;

    if (choice === "schedule") {
      this.openNewScheduleFormWithDate(this.choicePayload);
    } else if (choice === "vacation") {
      this.openNewVacationFormWithPayload(this.choicePayload);
    }
    this.choicePayload = null;
  }

  openNewVacationForm() {
    this.selectedVacationData = null;
    this.vacationFormDialog = true;
  }

  // eslint-disable-next-line
  openNewVacationFormWithPayload(payload: {
    date: string;
    employeeId: number;
  }) {
    this.selectedVacationData = {
      employeeId: payload.employeeId,
      date: payload.date,
    };
    this.vacationFormDialog = true;
  }

  openNewScheduleFormWithDate(payload: { date: string; employeeId: number }) {
    const emp = this.employees.find(e => e.id === payload.employeeId);
    this.selectedSchedule = {
      date: payload.date,
      departmentId: emp?.primaryDepartmentId,
      assignee: payload.employeeId,
      shiftId: emp?.shift,
      startTime: this.shiftOptions.find(s => s.id === emp?.shift)?.startTime,
      endTime: this.shiftOptions.find(s => s.id === emp?.shift)?.endTime,
      // eslint-disable-next-line
    } as any;
    this.formDialog = true;
  }

  openEditScheduleForm(schedule: Schedule) {
    if (!schedule) return; // If they clicked a mock visual block without real data
    this.selectedSchedule = schedule;
    this.formDialog = true;
  }

  // eslint-disable-next-line
  async handleSaveSchedule(formData: any) {
    try {
      if (this.selectedSchedule && this.selectedSchedule.id) {
        const updateData: Schedule = {
          ...this.selectedSchedule,
          ...formData,
        };
        await this.$store.dispatch("schedule/updateSchedule", {
          schedule: updateData,
          start: this.viewStart,
          end: this.viewEnd,
          department: this.filters.departmentId ?? undefined,
          titleId: this.filters.titleId ?? undefined,
        });
      } else {
        const schedules = Array.isArray(formData) ? formData : [formData];
        for (const item of schedules) {
          const createData: CreateScheduleRequest = { ...item };
          await this.$store.dispatch("schedule/addSchedule", {
            schedule: createData,
            start: this.viewStart,
            end: this.viewEnd,
            department: this.filters.departmentId ?? undefined,
            titleId: this.filters.titleId ?? undefined,
          });
        }
      }
      this.fetchData();
    } catch (error) {
      console.error("Error saving schedule:", error);
    }
  }

  openCreateCensus(payload: { date: string }) {
    this.selectedCensusForm = {
      // eslint-disable-next-line @typescript-eslint/camelcase
      census_date: payload.date,
      census: 0,
    };
    this.censusDialog = true;
  }

  openEditCensus(censusRecord: PatientCensus) {
    this.selectedCensusForm = { ...censusRecord };
    console.log(this.selectedCensusForm);
    this.censusDialog = true;
  }

  async saveCensus() {
    try {
      if (this.selectedCensusForm.id) {
        await this.$store.dispatch(
          "census/updateCensus",
          this.selectedCensusForm,
        );
      } else {
        await this.$store.dispatch("census/addCensus", this.selectedCensusForm);
      }
      this.censusDialog = false;
      this.fetchData(); // Refresh data to get the updated census and PPD
    } catch (error) {
      console.error("Error saving census:", error);
    }
  }

  get employees() {
    const employeesList = this.$store.state.directory.employees ?? [];
    let list = _.map(
      _.orderBy(employeesList, [
        employee => `${employee.firstName} ${employee.lastName}`.toLowerCase(),
      ]),
      employee => ({
        ...employee,
        text: `${employee.firstName} ${employee.lastName}`,
      }),
    );

    if (this.filters.employeeName) {
      const search = this.filters.employeeName.toLowerCase();
      list = list.filter(e => e.text.toLowerCase().includes(search));
    }

    if (this.filters.shiftId) {
      list = list.filter(e => e.shift === this.filters.shiftId);
    }

    if (this.filters.departmentId) {
      list = list.filter(
        e => e.primaryDepartmentId === this.filters.departmentId,
      );
    }

    if (this.filters.titleId) {
      list = list.filter(e => e.titleId === this.filters.titleId);
    }

    return list;
  }

  get departments(): Department[] {
    return this.$store.getters["company/departments"]?.map(
      (item: Department) => {
        return {
          ...item,
          header: undefined,
        };
      },
    );
  }

  get titles(): DepartmentTitle[] {
    return this.$store.getters["departmentAdmin/companyTitles"]?.map(
      (item: DepartmentTitle) => {
        return {
          ...item,
          header: undefined,
        };
      },
    );
  }

  get schedulePPD() {
    return this.$store.state.schedule.schedulePPD || [];
  }

  get schedulePPDFallback() {
    return this.$store.state.schedule.schedulePPDFallback || [];
  }

  get census() {
    return this.$store.state.census.census || [];
  }

  // eslint-disable-next-line
  get vacations(): any[] {
    return this.$store.state.vacation.vacations || [];
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get timeOffRequests(): any[] {
    return this.$store.state.schedule.timeOffRequests || [];
  }

  get openShifts() {
    const allOpenShifts: Schedule[] =
      this.$store.state.schedule.openShifts || [];
    return allOpenShifts.map((s: Schedule) => ({
      ...s,
      departmentName:
        this.departments?.find(d => d.id === s.departmentId)?.name || "",
      departmentColor: "#2196f3",
    }));
  }

  get transferRequestsCount(): number {
    return (this.$store.getters["scheduleTransfer/schedules"] || []).length;
  }

  get isOwner(): boolean {
    return checkSelfRole("owner");
  }
}
